import FinancialDocumentRowsTable from 'src/features/financialDocumentRows/components/tables/FinancialDocumentRowsTable';
import { useFinancialDocumentTabContext } from 'src/features/financialDocuments/utils/tabContext';

/** Rows tab of the financial document dashboard; reads the document details from outlet context. */
const FinancialDocumentRowsTab = () => {
    const { documentStatus, currency } = useFinancialDocumentTabContext();

    return <FinancialDocumentRowsTable documentStatus={documentStatus} currency={currency} />;
};

export default FinancialDocumentRowsTab;
